'use client';

import { c as _c } from "react/compiler-runtime";
import EarnFantokens from '@/entities/Celebrity/EarnFantokens';
export default function EarnFantokensClient() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <EarnFantokens />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}